module.exports = __webpack_public_path__ + "img/Low-stock.e2b03e63.svg";